import * as React from 'react';

export default props => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <path
            fillRule='evenodd'
            d='M0 2.005C0 .898.897 0 2.005 0h19.99C23.102 0 24 .897 24 2.005v19.99A2.005 2.005 0 0 1 21.995 24H2.005A2.005 2.005 0 0 1 0 21.995V2.005zM3 6h18v3H3V6zm0 9h18v3H3v-3z'
        />
    </svg>
)
